import { api } from "config/axios-context";

export const changeEventIsDone = async (model: {id: number, isDone: boolean}) => {
    const response = await api.put(`/BookingEvent/markAsDone`, {
        id: model.id,
        isDone: model.isDone
    });

    if (!response.success) {
        throw response.statusText;
    }

    return response;
};
